// AUTO-GENERATED by scripts/generate-target-catalog.ts.
// Do not edit by hand — run `pnpm catalog:generate` to refresh.
/**
 * Generated catalog of builtin target IDs (directory names under `src/targets/`).
 * No descriptor imports — keeps this module on the schema-safe side of the
 * `schema.ts → descriptors → ValidatedConfig → schema.ts` cycle.
 */
export const BUILTIN_TARGET_IDS = [
  'aider',
  'amazon-q',
  'amp',
  'antigravity',
  'augment-code',
  'claude-code',
  'cline',
  'codex-cli',
  'continue',
  'copilot',
  'crush',
  'cursor',
  'deepagents-cli',
  'factory-droid',
  'gemini-cli',
  'goose',
  'jules',
  'junie',
  'kilo-code',
  'kiro',
  'opencode',
  'pi-agent',
  'qwen-code',
  'replit-agent',
  'roo-code',
  'rovodev',
  'trae',
  'warp',
  'windsurf',
  'zed',
] as const;

export type BuiltinTargetId = (typeof BUILTIN_TARGET_IDS)[number];

export function isBuiltinTargetId(value: string): value is BuiltinTargetId {
  return (BUILTIN_TARGET_IDS as readonly string[]).includes(value);
}
